import { BinaryWriter } from "../binary.js";
import { ClientOp, ServerOp } from "../opcodes.js";
/**
 * O bestiário (PRD §15.5).
 *
 * ## Três marcos, e por que três
 *
 * Um marco só é uma barra que enche uma vez e some. Dez são uma planilha. Três — **viu**,
 * **caçou**, **conhece** — são o número em que cada um ainda significa alguma coisa
 * diferente: o primeiro é achar a criatura, o segundo é aprender a matá-la, e o terceiro é
 * ter passado tempo naquele terreno de caça.
 *
 * A recompensa por marco existe porque a contagem sozinha é um número que ninguém persegue.
 * O que ela paga é **informação** — a resistência da criatura, o que ela larga —, e não
 * poder: pagar poder faria caçar a mesma espécie mil vezes ser a forma ótima de progredir,
 * que é o oposto do que doze terrenos de caça existem para provocar.
 *
 * ## Por que a contagem entrou antes da tela
 *
 * `character_bestiary` entrou na migration 006, junto com as flags, e a tela só agora. Não
 * há como preencher retroativamente: a primeira coisa que o sistema comunicaria ao veterano
 * seria que o tempo dele não contou.
 */
/** Os três marcos, em número de abates. */
export const BESTIARY_MILESTONES = [1, 25, 100];
/** O que cada marco revela. É informação, e nunca poder. */
export const BESTIARY_REWARDS = [
    'nome e aparência',
    'vida, ataque e o que ela larga',
    'resistências e ritmo de retorno',
];
/** Em que marco esta contagem está, de 0 a 3. */
export function bestiaryStage(kills) {
    let stage = 0;
    for (const milestone of BESTIARY_MILESTONES)
        if (kills >= milestone)
            stage += 1;
    return stage;
}
/**
 * `0x12 BestiaryRequest` — cliente→servidor. "Abra o bestiário."
 *
 * Sem corpo: o servidor já sabe de quem é a contagem. Um pedido que carregasse o id do
 * personagem seria um pedido que alguém tentaria adulterar para ler a ficha alheia.
 *
 * ```
 * op:u8
 * ```
 */
export function encodeBestiaryRequest(writer = new BinaryWriter(2)) {
    writer.u8(ClientOp.Bestiary);
    return writer;
}
export function encodeBestiary(packet, writer = new BinaryWriter(512)) {
    writer.u8(ServerOp.Bestiary).u16(packet.entries.length);
    for (const entry of packet.entries) {
        writer
            .u8(entry.species)
            .u32(entry.kills)
            .str8(entry.name)
            .u16(entry.maxHealth)
            .u16(entry.attackPower)
            .u8(entry.resistances.length);
        for (const value of entry.resistances)
            writer.u8(value);
    }
    return writer;
}
export function decodeBestiary(reader) {
    const count = reader.u16();
    const entries = new Array(count);
    for (let i = 0; i < count; i++) {
        const species = reader.u8();
        const kills = reader.u32();
        const name = reader.str8();
        const maxHealth = reader.u16();
        const attackPower = reader.u16();
        const resistanceCount = reader.u8();
        const resistances = new Array(resistanceCount);
        for (let r = 0; r < resistanceCount; r++)
            resistances[r] = reader.u8();
        entries[i] = { species, kills, name, maxHealth, attackPower, resistances };
    }
    return { entries };
}
//# sourceMappingURL=bestiary.js.map